export default "__VITE_ASSET__Bpis$m38__"